/**
 * 首页路由配置
 */
export default {
  name: 'other-query',
  path: '/home/info-search/other-query',
  component: () => import('../../views/other-query'),
  meta: {
    label: '他人查询',
    isNotMenu: true,
    activeMenu: '/home/info-search',
    permission: 'IEBDC:SY:XXCX:TRCX',
    construction: 'IEBDC:SY:XXCX:TRCX:SFZJ',
    icon: 'iconbudongchan',
    background: 'linear-gradient(to bottom right, #8C10F8 , #C079FF)'
  }
};
